import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Plans.css';

const Plans = () => {
  const [billingPeriod, setBillingPeriod] = useState('monthly'); // monthly, halfyearly, yearly

  const plans = [
    {
      name: 'CableBiz Basic',
      monthly: { price: 300, subscribers: 500, validity: 30, savings: 0 },
      halfyearly: { price: 1500, subscribers: 500, validity: 180, savings: 300 },
      yearly: { price: 3000, subscribers: 500, validity: 365, savings: 600 }
    },
    {
      name: 'CableBiz Plus',
      monthly: { price: 500, subscribers: 1000, validity: 30, savings: 0 },
      halfyearly: { price: 2500, subscribers: 1000, validity: 180, savings: 500 },
      yearly: { price: 5000, subscribers: 1000, validity: 365, savings: 1000 }
    },
    {
      name: 'CableBiz Popular',
      monthly: { price: 800, subscribers: 2000, validity: 30, savings: 0 },
      halfyearly: { price: 4000, subscribers: 2000, validity: 180, savings: 800 },
      yearly: { price: 8000, subscribers: 2000, validity: 365, savings: 1600 }
    },
    {
      name: 'CableBiz Premium',
      monthly: { price: 1200, subscribers: 4000, validity: 30, savings: 0 },
      halfyearly: { price: 6000, subscribers: 4000, validity: 180, savings: 1200 },
      yearly: { price: 12000, subscribers: 4000, validity: 365, savings: 2400 }
    },
    {
      name: 'CableBiz Royal',
      monthly: { price: 1500, subscribers: 5000, validity: 30, savings: 0 },
      halfyearly: { price: 7800, subscribers: 5000, validity: 180, savings: 1200 },
      yearly: { price: 18000, subscribers: 5000, validity: 365, savings: 12000 }
    }
  ];

  const getPeriodLabel = () => {
    switch (billingPeriod) {
      case 'monthly':
        return 'Mo';
      case 'halfyearly':
        return 'Hy';
      case 'yearly':
        return 'Yr';
      default:
        return 'Mo';
    }
  };

  const getPeriodName = () => {
    switch (billingPeriod) {
      case 'monthly':
        return 'Monthly';
      case 'halfyearly':
        return 'Half Yearly';
      case 'yearly':
        return 'Yearly';
      default:
        return 'Monthly';
    }
  };

  return (
    <div className="plans-page">
      <section className="plans-hero section">
        <div className="container">
          <h1 className="page-title">Subscription Plans</h1>
          <p className="page-subtitle">
            Choose the perfect plan for your cable TV business. All plans include GST.
          </p>
        </div>
      </section>

      <section className="plans-content section">
        <div className="container">
          {/* Billing Period Toggle */}
          <div className="billing-toggle">
            <button
              className={`toggle-btn ${billingPeriod === 'monthly' ? 'active' : ''}`}
              onClick={() => setBillingPeriod('monthly')}
            >
              Monthly
            </button>
            <button
              className={`toggle-btn ${billingPeriod === 'halfyearly' ? 'active' : ''}`}
              onClick={() => setBillingPeriod('halfyearly')}
            >
              Half Yearly
            </button>
            <button
              className={`toggle-btn ${billingPeriod === 'yearly' ? 'active' : ''}`}
              onClick={() => setBillingPeriod('yearly')}
            >
              Yearly
            </button>
          </div>

          {/* Plans Grid */}
          <div className="plans-grid">
            {plans.map((plan, index) => {
              const currentPlan = plan[billingPeriod];
              const isPopular = plan.name === 'CableBiz Popular';
              
              return (
                <div key={index} className={`plan-card ${isPopular ? 'popular' : ''}`}>
                  {isPopular && <div className="popular-badge">Most Popular</div>}
                  
                  <div className="plan-header">
                    <h3 className="plan-name">{plan.name}</h3>
                    <div className="plan-price">
                      <span className="currency">₹</span>
                      <span className="amount">{currentPlan.price}</span>
                      <span className="period">/{getPeriodLabel()}</span>
                    </div>
                  </div>

                  {currentPlan.savings > 0 && (
                    <div className="savings-badge">
                      Customer saving ₹{currentPlan.savings.toLocaleString('en-IN')}
                    </div>
                  )}

                  <div className="plan-features">
                    <div className="feature-item">
                      <span className="feature-icon">👥</span>
                      <span className="feature-value">{currentPlan.subscribers.toLocaleString('en-IN')}</span>
                      <span className="feature-label">Subscriber</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">📅</span>
                      <span className="feature-value">{currentPlan.validity}</span>
                      <span className="feature-label">Days Validity</span>
                    </div>
                    <div className="feature-item">
                      <span className="feature-icon">ℹ️</span>
                      <span className="feature-label">* GST Extra</span>
                    </div>
                  </div>

                  <Link 
                    to="/contact" 
                    className="btn btn-primary btn-full plan-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      // You can add payment integration here
                      alert(`You selected ${plan.name} - ${getPeriodName()} plan. Contact us to proceed with payment.`);
                    }}
                  >
                    Buy Now
                  </Link>
                </div>
              );
            })}
          </div>

          {/* Additional Info */}
          <div className="plans-info">
            <div className="info-card">
              <h3>Why Choose CableBiz?</h3>
              <ul>
                <li>✓ Complete billing and management solution</li>
                <li>✓ Real-time reports and analytics</li>
                <li>✓ Mobile apps for operators and customers</li>
                <li>✓ 24/7 technical support</li>
                <li>✓ Regular updates and new features</li>
              </ul>
            </div>
            <div className="info-card">
              <h3>Need Help Choosing?</h3>
              <p>Not sure which plan is right for you? Contact our sales team for personalized recommendations based on your business needs.</p>
              <Link to="/contact" className="btn btn-outline">
                Contact Sales
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Plans;

